import React from 'react';

const getValue = (value, key, fallback = 0) => typeof value === 'object' ? (value?.[key] ?? fallback) : (value ?? fallback);

const SummaryCard = ({summary}) => {
  if (!summary) return null;
  const items = [
    {label: 'Words learned', value: getValue(summary.vocabulary, 'totalLearnedCount'), icon: 'translate', tone: 'indigo'},
    {label: 'Grammar progress', value: `${Math.round(getValue(summary.grammar, 'levelProgress') * 100)}%`, icon: 'menu_book', tone: 'teal'},
    {label: 'Average score', value: Number(getValue(summary.writing, 'averageRating')).toFixed(1), icon: 'edit_note', tone: 'violet'}
  ];

  return <section className="summary-card surface-card" aria-label="Learning progress">
    <div className="summary-streak"><i className="material-icons" aria-hidden="true">local_fire_department</i>
      <div><strong>{summary.streakDays || 0}</strong><span>day streak</span></div>
    </div>
    <div className="summary-metrics">{items.map((item) => <div className="summary-metric" key={item.label}><span className={`summary-metric__icon summary-metric__icon--${item.tone}`}><i
        className="material-icons" aria-hidden="true">{item.icon}</i></span>
      <div><strong>{item.value}</strong><span>{item.label}</span></div>
    </div>)}</div>
  </section>;
};

export default SummaryCard;
